export const REGIONAL_SEARCH_PROPS = {
  searchLabel: {
    type: String,
    default: () => 'Buscar ...',
  },
  highwayLabel: {
    type: String,
    default: () => 'Autopista',
  },
  highwaySelectionOptions: {
    type: Array,
    default: () => [],
  },
  townLabel: {
    type: String,
    default: () => 'Población',
  },
  townSelection: {
    type: Boolean,
    default: () => true,
  },
  provinceLabel: {
    type: String,
    default: () => 'Provincia',
  },
  provinceSelection: {
    type: Boolean,
    default: () => true,
  },
  regionLabel: {
    type: String,
    default: () => 'Comunidad autónoma',
  },
  regionSelection: {
    type: Boolean,
    default: () => true,
  },
};
